module.exports = __webpack_public_path__ + "img/escultura-consulta-alteracion.dffb5827.png";